import React, { useEffect, useState } from "react";
import Sidebar from "../admin/Sidebar";
import TopBar from "../components/TopBar";
import { Table, Button, Badge, Form, Pagination } from "react-bootstrap";
import { fetchAllNotifications, markNotificationRead } from "../services/notificationService";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const AdminNotifications = () => {
    const [notifications, setNotifications] = useState([]);
    const [filteredNotifications, setFilteredNotifications] = useState([]);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        loadNotifications();
    }, []);

    const loadNotifications = async () => {
        try {
            const { data } = await fetchAllNotifications();
            setNotifications(data);
            setFilteredNotifications(data);
        } catch (err) {
            console.log("Failed to load notifications");
        }
    };

    const handleClick = async (notification) => {
        if (!notification.isRead) {
            await markNotificationRead(notification._id);
        }
        navigate(notification.link);
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        const filtered = notifications.filter(
            (n) =>
                n.title.toLowerCase().includes(query.toLowerCase()) ||
                n.message.toLowerCase().includes(query.toLowerCase()) ||
                n.type.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredNotifications(filtered);
        setCurrentPage(1);
    };

    // Pagination calculations
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentNotifications = filteredNotifications.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredNotifications.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div style={{ display: "flex", height: "100vh" }}>
            <Sidebar setIsSidebarOpen={setIsSidebarOpen} />

            <div
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    transition: "margin-left 0.3s ease",
                    marginLeft: isSidebarOpen ? "250px" : "80px",
                    padding: "20px",
                }}
            >
                <TopBar />

                <div className="container mt-4">

                    {/* Search Box */}
                    <div className="d-flex justify-content-end mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Search notifications..."
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{ width: "300px" }}
                        />
                    </div>

                    {/* Table */}
                    <Table striped bordered hover responsive className="shadow-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Message</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th style={{ width: "120px" }}>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentNotifications.length === 0 && (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        No notifications available
                                    </td>
                                </tr>
                            )}

                            {currentNotifications.map((n, index) => (
                                <tr
                                    key={n._id}
                                    style={{
                                        backgroundColor: n.isRead ? "#fff" : "#f0f7ff",
                                    }}
                                >
                                    <td>{indexOfFirstItem + index + 1}</td>
                                    <td><strong>{n.title}</strong></td>
                                    <td>{n.message}</td>
                                    <td><Badge bg="secondary">{n.type}</Badge></td>
                                    <td>
                                        {n.isRead ? (
                                            <Badge bg="success">Read</Badge>
                                        ) : (
                                            <Badge bg="primary">Unread</Badge>
                                        )}
                                    </td>
                                    <td>{new Date(n.createdAt).toLocaleString()}</td>
                                    <td>
                                        <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={() => handleClick(n)}
                                        >
                                            View
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <Pagination className="justify-content-center">
                            <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
                            {Array.from({ length: totalPages }, (_, i) => (
                                <Pagination.Item key={i + 1} active={currentPage === i + 1} onClick={() => paginate(i + 1)}>
                                    {i + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    )}

                </div>
            </div>
        </div>
    );
};

export default AdminNotifications;
